<template>
  <div class="vendas-periodo">
    <g-card
      class="card-vendas-periodo"
      margem="20px"
      :expansivel="true"
      :comecaFechado="false"
    >
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho">Vendas por Período</div>
          <div class="header-icons">
            <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              @click="limpar"
            />
            <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="Buscar()"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="vendas-periodo-conteudo">
          <div class="codigo-nome-produto">
            <div class="codigo-produto">
              <div class="codigo-produto-titulo titulo-conteudo-filtros">Nome do Produto</div>
              <PDropDown
                  v-model="novoFiltroVendas.NomeProduto"
                  class="nome-produto-input"
                  optionLabel="labelProduto"
                  optionValue="produtoId"
                  placeholder="Insira o nome do produto"
                  @filter="getProduto($event.value)"
                  :filter="true"
                  :options="ProdutoArray"
              />
            </div>
          </div>

          <div class="data-ultima-venda">
            <div class="ultima-venda-titulo titulo-conteudo-filtros">Data da última venda</div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                  class="ultima-venda-inicio-input input-label"
                  placeholderinput="Início"
                  alturainput="40px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  v-model="DataInicioUltimaVenda"
                  :dataPassadas="true"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                  class="ultima-venda-termino-input input-label"
                  placeholderinput="Término"
                  alturainput="40px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  v-model="DataFinalUltimaVenda"
                  :dataPassadas="true"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros">Unidade</div>
            <PDropDown
              class="unidade-input input-label unidade"
              placeholder="TODAS"
              :filter="true"
              :options="EmpresaArray"
              optionLabel="nome"
              optionValue="id"
              v-model="novoFiltroVendas.UnidadeId"
            >
            </PDropDown>
          </div>

          <div class="cliente">
            <div class="cliente-titulo titulo-conteudo-filtros">Cliente</div>
            <!-- <VMultiSelect
              class="cliente-input input-label"
              placeholder="Selecione o cliente"
              :filter="true"
              :filterFields="[
                'razaoSocial',
                'codigoExterno',
                'nomeFantasia',
                'situacao',
                'estadoCidade',
                'cnpj',
              ]"
              :options="ClienteArray"
              optionLabel="nomeFantasia"
              optionValue="id"
              @filter="buscarClientes($event.value)"
              v-model="novoFiltroVendas.ClienteId"
            >
              <template #option="slotProps">
                <cliente-dropdown-item
                  :dadosCliente="slotProps.option"
                ></cliente-dropdown-item>
              </template>
            </VMultiSelect> -->
            <cliente-dropdown
              class="cliente-input input-label"
              @change="ativaClienteAgrupador"
              v-model="novoFiltroVendas.ClienteId"
              :empresaId="novoFiltroVendas.UnidadeId"
              :representanteId="this.$store.state.representanteSelecionadoId"
            />
          </div>

          <div class="ordenacao">
            <div class="ordenacao-titulo titulo-conteudo-filtros">Ordenação</div>
            <PDropDown
              class="ordenacao-input input-label"
              placeholder="Selecione a ordenação"
              :filter="true"
              :options="OrdenacaoArray"
              v-model="novoFiltroVendas.Ordenacao"
              optionLabel="text"
              optionValue="value"
            ></PDropDown>
          </div>

            <div class="linha">
              <div class="linha-titulo titulo-conteudo-filtros">Em Linha</div>
              <PDropDown
                class="linha-input input-label"
                placeholder="Selecione"
                :options="emLinhaArray"
                v-model="novoFiltroVendas.EmLinha"
                optionLabel="campo"
                optionValue="value"
              ></PDropDown>
            </div>

            <div class="parametros">
              <div class="parametros-titulo titulo-conteudo-filtros">Outros Parâmetros</div>
              <div class="consultar-dados checkbox">
                <PCheckBox
                  :binary="true"
                  :disabled="ClienteAgrupadorAtiva"
                  id="consultar-dados"
                  class="checkbox-consultas"
                  v-model="novoFiltroVendas.ConsultarDadosClienteAgrupador"
                ></PCheckBox>
                <label
                  class="consultarDados label-checkbox"
                  for="consultar-dados"
                >
                  Consultar dados do cliente agrupador
                </label>
              </div>
            </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="15px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="Buscar()"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card
      margem="20px"
      paddingDefault="0 0em 1em"
      :expansivel="false"
      :temCabecalho="false"
      class="card-resultado"
    >
      <div v-if="grid" class="">
        <img
          class="icone-global-imagemfundo"
          src="@/assets/imgs/Ilustracao_erro.svg"
        />
        <div class="texto-padrao-imagemfundo">
          Verifique os filtros e clique em buscar para exibir os resultados
        </div>
      </div>

      <div v-else-if="!grid">
        <g-data-table
          Titulo="Vendas"
          altura="auto"
          :colunas="Colunas"
          :valores="VendasPorPeriodoArray"
          :Paginacao="true"
          :NumeroLinhas="100"
          :columnSize="'10px'"
          :FiltrosEspecificos="true"
          :Filtros="Filtro"
          v-on:duploClickLinha="detalhesPedidoVenda"
          :EscondeColunaBotao="true"
          :campoAgrupador="'empresaCliente'"
          datakey = "codigo"
          :campoExibicaoGrupo="'empresaCliente'"
        ></g-data-table>
      </div>
    </g-card>
  </div>
</template>


  <script>
import VendasPeriodo from "./VendasPeriodo.js";
export default VendasPeriodo;
</script>

  <style scoped>
.card-orcamento-header {
  display: flex;
  justify-content: space-between;
}

.header-icons-consulta {
  display: flex;
  justify-content: flex-end;
}

.trash-box-consulta {
  margin-left: 5px;
}

.card-vendas-periodo-titulo {
  color: #4f2c19;
  text-align: left;
  font-weight: bold;
  align-self: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.titulo {
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  padding: 5px 0;
}

.ultima-venda-data {
  color: #747474;
  font-family: Montserrat;
}

.checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}
.label-checkbox {
  color: #8a8a8a;
  text-align: left;
  font-size: 15px;
  font-family: "MontSerrat";
  margin-left: 5px;
}

.input-label {
  margin-bottom: 15px;
}

.codigo-nome-produto {
  width: 100%;
}

.card-resultado-text-small {
  color: #4f4c4d;
  font-family: "MontSerrat";
}

.card-resultado-content {
  display: flex;
  flex-direction: column;
}

.imagem-nenhuma-info {
  margin: 60px auto 20px auto;
  max-height: 500px;
}

.buscar-button {
  display: flex;
  align-content: center;
  justify-content: center;
}

/* .linha {
  width: 100px;
} */

@media (min-width: 310px) {
  .unidade { order: 1 }
  .buscar-button-header {
    display: none;
  }
  .card-vendas-periodo-titulo {
    font-size: 16px;
  }

  /* .vendas-periodo-conteudo {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
  } */

  .vendas-periodo-conteudo {
    display: grid;
    /* grid-template-columns: 48.5% 48%; */
    grid-template-columns: 1fr;
    grid-template-rows: repeat(5, auto);
    grid-column-gap: 20px;
  }

  .unidade {
    grid-area: 1 / 1 / 2 / 2;
  }
  .cliente {
    grid-area: 2 / 1 / 3 / 2;
  }
  .codigo-nome-produto {
    grid-area: 3 / 1 / 4 / 2;
  }
  .data-ultima-venda {
    grid-area: 5 / 1 / 6 / 2;
  }
  .ordenacao {
    grid-area: 6 / 1 / 7 / 2;
  }
  .linha {
    grid-area: 7 / 1 / 8 / 2;
  }
  .parametros{
    grid-area: 8 / 1 / 9 / 2;
  }

  .titulo {
    font-size: 14px;
  }



  .ultima-venda-input {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 100%;
    grid-column-gap: 4%;
  }
  .ultima-venda-inicio {
    grid-area: 1 / 1 / 2 / 2;
  }
  .ultima-venda-data {
    grid-area: 1 / 2 / 2 / 3;
    align-self: center;
  }
  .ultima-venda-termino {
    grid-area: 1 / 3 / 2 / 4;
  }

  .input-label {
    width: 100%;
  }

  .buscar-button-filtro {
    display: flex;
    justify-content: center;
    align-items: self-end;
  }

  .imagem-nenhuma-info {
    height: 15vh;
  }
}

@media (min-width: 368px) {
  .card-vendas-periodo-titulo {
    font-size: 18px;
  }

  .linha-parametros {
    display: flex;
    column-gap: 25px;
  }
}

@media (min-width: 600px) {
  .buscar-button-header {
    display: block;
    margin-left: 15px;
  }

  .card-vendas-periodo-titulo {
    font-size: 20px;
  }

  /* .vendas-periodo-conteudo {
    display: grid;
    grid-template-columns: 48.5% 48%;
    grid-template-rows: repeat(5, auto);
    grid-column-gap: 20px;
  }

  .codigo-nome-produto {
    grid-area: 1 / 1 / 2 / 2;
  }
  .data-ultima-venda {
    grid-area: 1 / 2 / 2 / 3;
  }
  .unidade {
    grid-area: 2 / 1 / 3 / 3;
  }
  .cliente {
    grid-area: 3 / 1 / 4 / 3;
  }
  .ordenacao {
    grid-area: 4 / 1 / 5 / 3;
  }
  .linha-parametros {
    grid-area: 5 / 1 / 6 / 3;
  } */

  .buscar-button-filtro {
    display: none;
  }

  .imagem-nenhuma-info {
    height: 25vh;
  }
}

@media (min-width: 801px) {
  .vendas-periodo-conteudo {
    grid-template-columns: 52% 45.5%;
    grid-template-rows: repeat(4, auto);
    margin: 20px 20px 0 20px;
  }

  .unidade {
    grid-area: 1 / 1 / 2 / 2;
  }
  .cliente {
    grid-area: 1 / 2 / 2 / 3;
  }
  .codigo-nome-produto {
    grid-area: 2 / 1 / 3 / 2;
  }
  .data-ultima-venda {
    grid-area: 2 / 2 / 3 / 3;
  }
  .ordenacao {
    grid-area: 6 / 1 / 7 / 2;
  }
  .linha {
    grid-area: 6 / 2 / 7 / 3;
  }
}

@media (min-width: 1025px) {
  .card-vendas-periodo-titulo {
    font-size: 22px;
  }

  .vendas-periodo-conteudo {
    grid-template-columns: 52% 46%;
    grid-template-rows: repeat(4, auto);
    margin: 20px 20px 0 20px;
  }

  .card-resultado-text-small {
    font-size: 16px;
  }

  .imagem-nenhuma-info {
    height: 35vh;
  }
}

@media (min-width: 1281px) {
  .vendas-periodo-conteudo {
    grid-template-columns: repeat(4, minmax(6em, 1fr));
    grid-template-rows: repeat(2, auto);
  }

  .unidade {
    grid-area: 1 / 1 / 2 / 2;
  }
  .cliente {
    grid-area: 1 / 2 / 2 / 3;
  }
  .codigo-nome-produto {
    grid-area: 1 / 3 / 2 / 4;
  }
  .data-ultima-venda {
    grid-area: 1 / 4 / 2 / 5;
  }
  .ordenacao {
    grid-area: 2 / 1 / 3 / 2;
  }
  .linha {
    grid-area: 2 / 2 / 3 / 3;
  }
  .parametros {
    grid-area: 2 / 3 / 3 / 5;
  }
}

@media (min-width: 1500px) {
  /* .vendas-periodo-conteudo {
    grid-template-columns: 25% 20% repeat(2, 18.5em) minmax(6em, auto);
    grid-template-rows: repeat(2, auto);
  }

  .codigo-nome-produto {
    grid-area: 1 / 1 / 2 / 2;
  }
  .data-ultima-venda {
    grid-area: 1 / 2 / 2 / 3;
  }
  .unidade {
    grid-area: 1 / 3 / 2 / 4;
  }
  .cliente {
    grid-area: 1 / 4 / 2 / 5;
  }
  .ordenacao {
    grid-area: 1 / 5 / 2 / 6;
  }
  .linha-parametros {
    grid-area: 2 / 1 / 3 / 3;
  } */
}
</style>